import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { Observable } from 'rxjs';

@Component({
    selector: 'bg-touch-spin',
    templateUrl: './touch-spin.component.html',
    imports: [CommonModule, FormsModule],
})
export class TouchSpinComponent implements OnInit, OnChanges {
    @Input() min: number;
    @Input() max: number;
    @Input() value: number;
    @Input() color: Observable<string>;
    @Input() id: number;
    @Output() onSelected: EventEmitter<any> = new EventEmitter<any>();
    addDisbled: boolean = false;
    tSpinAdd() {
        this.addDisbled = this.value >= +this.max - 1;
        this.onSelected.emit({
            selectedValue: this.value < +this.max ? this.value + 1 : +this.max,
            id: this.id,
        });
    }
    tSpinSub() {
        if (this.value > +this.min) this.addDisbled = false;
        this.onSelected.emit({
            selectedValue: this.value > +this.min ? this.value - 1 : +this.min,
            id: this.id,
        });
    }
    constructor() {}

    ngOnInit() {
        if (this.value == this.max) this.addDisbled = true;
    }
    ngOnChanges() {
        if (this.value == this.max) this.addDisbled = true;
        else this.addDisbled = false;
    }
}
